import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserInfoService } from './user-info.service';
declare let ga: Function;
declare var gtag
@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsEventsService {
  ga_code = environment.ga_code;
  gtag_code = environment?.gtag_code
  constructor(private userInfoService: UserInfoService) {
    ga('create', this.ga_code, 'auto');  // <- add the UA-ID from your tracking code
    if(!environment.production) {
      gtag('config', this.gtag_code);
    }
  }

   public emitEvent(eventCategory: string,
                    eventAction: string,
                    eventLabel: any = null,
                    eventValue: any = null) {
                    let uid = this.userInfoService?.userInfo?.user?.user_id;
                    let orgID = this.userInfoService?.userInfo?.organization?.organization_id;
                      gtag('event', 'eventClick', {
                        category: eventCategory,
                        label: eventLabel,
                        action : eventAction,
                        value : eventValue,
                        app_name: 'service center for channel',
                        app_id: "reseller-portal",
                        uid : uid,
                        org_id: orgID
                     });

              ga('send', 'event', {
                eventCategory,
                eventLabel,
                eventAction,
                eventValue
             });
   }
}
